import React, { useState, useEffect } from "react";
import { Typography } from "@mui/material";

import { types } from "../../Editor/itemTypes";
import CustomTreeList from "./CustomTreeList";
import { TreeProvider } from "./treeContext";

const setExpandedIds = (initialItems, keys) => {
  initialItems.forEach((item) => {
    if (
      item.items.length > 0 &&
      item.original?.itemExtra?.curate?.show === 0 &&
      item.original?.itemExtra?.curate?.hideTree === 0
    ) {
      keys.push(item.id);
      setExpandedIds(item.items, keys);
    }
  });
};

function updateObj(obj /*, …*/) {
  for (var i = 1; i < arguments.length; i++) {
    for (var prop in arguments[i]) {
      var val = arguments[i][prop];
      if (typeof val == "object")
        // this also applies to arrays or null!
        updateObj(obj[prop], val);
      else obj[prop] = val;
    }
  }
  return obj;
}

const setQuestionTree = (items, indices, updateItem) => {
  items.forEach((item, index) => {
    if (indices.length > 1 && index === indices[0]) {
      // search
      const newIndices = indices.filter((_, index) => index !== 0); // remove first index
      setQuestionTree(item.items, newIndices, updateItem);
    }
    if (indices.length === 1 && index === indices[0]) {
      // update selected element
      updateObj(item, updateItem);
    }
  });
};

export default function CustomTreeView({
  questions, // questionTree
  handleUpdateTree = () => false, // update questionList
  isCurate = false, // show fewer items
  variant = "body1", // smaller (body2) or larger (body2) font
  locked = true, // preview only the questionnaire, don't make changes,
  handleSelect = (pos, checked) => false, // handle selected questions
}) {
  const [expanded, setExpanded] = useState([]);

  useEffect(() => {
    let keys = [];
    if (isCurate) {
      setExpandedIds(questions, keys);
    } else {
      keys = questions
        .filter((node) => node.type === types.container)
        .map((node) => node.id);
    }
    setExpanded((prev) => [...prev, ...keys]);
  }, [isCurate, questions]);

  const handleToggle = (node) => {
    let keys = [node.id];

    if (isCurate && !expanded.includes(node.id))
      setExpandedIds(node.items, keys);

    if (expanded.includes(node.id)) {
      // remove from list
      setExpanded((prev) => [...prev].filter((node) => !keys.includes(node)));
    } else {
      // add to list
      setExpanded((prev) => [...prev, ...keys]);
    }
  };

  const handleUpdateItem = (node, position, updateItem) => {
    let updateTree = structuredClone(questions);
    const positionArr = position.split(".");
    positionArr.pop(); // remove last empty string from array
    const indices = positionArr.map((p) => p - 1);
    setQuestionTree(updateTree, indices, updateItem);
    handleUpdateTree(updateTree);
  };

  return questions.length === 0 ? (
    <Typography variant={variant}>Geen items gevonden</Typography>
  ) : (
    <TreeProvider
      value={{
        variant,
        isCurate,
        locked,
        handleToggle,
        handleUpdateItem,
        handleSelect,
      }}
    >
      <CustomTreeList
        expanded={expanded}
        nodes={questions}
        position={null}
        indentLevel={null}
      />
    </TreeProvider>
  );
}
